import { AmountColWidth, NameColWidth, StorageName, WeightColWidth } from "../../../../enum/common-enum";
import { AgColDefsI, AgGridI } from "../../../ag-grid/ag-grid.model";
import { NumericCellRendererComponent } from "../../../ag-grid/numeric-cell-renderer/numeric-cell-renderer.component";
import { TextRendererComponent } from "../../../ag-grid/text-renderer/text-renderer.component";

export class JournalVouchersPopup {
}

const AccountDetails: AgColDefsI = {
  headerName: "Account Details",
  field: "accountLedgerName",
  minWidth: NameColWidth.MinWidth,
  maxWidth: NameColWidth.MaxWidth,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell px-0",
  editable: false,
  sortable: true,
  resizable: true,
  cellRenderer: TextRendererComponent,
};

const Currency: AgColDefsI = {
  headerName: "Currency",
  field: "currencyName",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell px-0",
  editable: false,
  sortable: true,
  resizable: true,
  cellRenderer: TextRendererComponent,
};
const FcAmount: AgColDefsI = {
  headerName: "Fc Amount",
  field: "fcAmount",
  resizable: true,
  sortable: true,
  editable: false,
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex:1,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams:{isAmt:true},
  headerClass: "px-0 custom-column-group-cell",
  cellClass: "px-0 custom-column-group-cell text-end",
};
const BaseAmount: AgColDefsI = {
  headerName: "Base Amount (AED)",
  field: "baseAmount",
  marryChildren: true,
  headerClass: "custom-column-group-cell justify-content-center px-0",
  children: [
    {
      headerName: "Debit",
      field: "baseDebitAmount",
      sortable: true,
      headerClass: "custom-column-group-cell child_header px-0",
      cellClass: "custom-column-group-cell text-end ",
      minWidth: AmountColWidth.MinWidth,
      maxWidth: AmountColWidth.MaxWidth,
      editable: false,
      cellRenderer: TextRendererComponent,
    },
    {
      field: "baseCreditAmount",
      sortable: true,
      headerClass: "custom-column-group-cell child_header px-0",
      cellClass: "custom-column-group-cell text-end",
      headerName: "Credit",
      minWidth: AmountColWidth.MinWidth,
      maxWidth: AmountColWidth.MaxWidth,
      editable: false,
      cellRenderer: TextRendererComponent,
    },
  ],
};
const PureWt: AgColDefsI = {
  headerName: "Pure Wt./Qty",
  field: "pureWt",
  marryChildren: true,
  headerClass: "custom-column-group-cell justify-content-center px-0",
  children: [
    {
      headerName: "Debit",
      field: "purityDebitWt",
      sortable: true,
      headerClass: "custom-column-group-cell child_header px-0",
      cellClass: "custom-column-group-cell text-end ",
      minWidth: WeightColWidth.MinWidth,
      maxWidth: WeightColWidth.MaxWidth,
      editable: false,
      cellRenderer: TextRendererComponent,
    },
    {
      field: "purityCreditWt",
      sortable: true,
      headerClass: "custom-column-group-cell child_header px-0",
      cellClass: "custom-column-group-cell text-end",
      headerName: "Credit",
      minWidth: WeightColWidth.MinWidth,
      maxWidth: WeightColWidth.MaxWidth,
      editable: false,
      cellRenderer: TextRendererComponent,
    },
  ],
};

const DescriptionCol: AgColDefsI = {
  headerName: "Description",
  field: "description",
  minWidth: NameColWidth.MinWidth,
  maxWidth: NameColWidth.MaxWidth,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell text-primary text-underline",
  editable: false,
  sortable: false,
  resizable: true,
  cellRenderer: TextRendererComponent,
};

export const ColDefsJournalVouchers: AgColDefsI[] = [
  AccountDetails,
  Currency,
  FcAmount,
  BaseAmount,
  PureWt,
  DescriptionCol,

]
export const AgGridJournalVouchers: AgGridI = {
  colDefs: ColDefsJournalVouchers,
  storageName: StorageName.JOURNAL_VOUCHERS_GRID,
  columnSettings: true,
  rowSelection: "multiple",
  rowHeight: 28,
};